exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".loader-primary {\n  background-color: rgba(0, 0, 0, 0.25);\n  margin-top: -297px;\n  height: 297px;\n  padding-top: 110px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/user/login/login.component.scss
// module id = 1122
// module chunks = 13